import { render, staticRenderFns } from "./CheckboxesField.vue?vue&type=template&id=80103174&scoped=true&lang=pug&"
import script from "./CheckboxesField.vue?vue&type=script&lang=js&"
export * from "./CheckboxesField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesField.vue?vue&type=style&index=0&id=80103174&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80103174",
  null
  
)

export default component.exports